import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ThingQrcode extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.thingQrcode}>
                <div className={styles.thingQrcodeTop}>
                    <div className={styles.thingQrcodeTopBig}>
                        <img className={styles.thingQrcodeTopBigPic} src={content.topContent.qrcodeUrl} />
                        <div className={styles.thingQrcodeTopBigTitle}>{content.topContent.qrcodeTitle}</div>
                    </div>
                    <div className={styles.thingQrcodeTopTxt}>
                        <div className={styles.thingQrcodeTopTitle}>{content.topContent.title}</div>
                        <div className={styles.thingQrcodeTopSubtitle}>{content.topContent.subTitle}</div>
                        <div className={styles.thingQrcodeTopBref}>{content.topContent.bref}</div>
                    </div>
                </div>
                <div className={styles.thingQrcodeBottom}>
                    <div className={styles.thingQrcodeBottomPicText}>
                        <img className={styles.thingQrcodeBottomPic} src={content.bottomContent.qrcodeUrl} />
                        <div className={styles.thingQrcodeBottomText}>
                            <div className={styles.thingQrcodeBottomTitle}>{content.bottomContent.title}</div>
                            <div className={styles.thingQrcodeBottomBref}>{content.bottomContent.subTitle}</div>
                        </div>
                    </div>
                    <img className={styles.thingQrcodeBottomNav} src={content.bottomContent.navPicUrl} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(ThingQrcode);
